// descontos-v2-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{valor} (1 ponto)": "%{valor} (1 punto)",
    "%{v}, gastando 1 ponto por abastecimento": "%{v}, gastando 1 punto por carga de combustible",
    "A opção de %{valor} (1 ponto) não aparece para quem não tem pontos suficientes.": "La opción de %{valor} (1 punto) no aparece para quien no tiene puntos suficientes.",
    "Na opção com pontos, o cliente gasta 1 ponto por abastecimento.": "En la opción con puntos, el cliente gasta 1 punto por carga de combustible.",
    "Nenhum abastecimento no período": "Ninguna carga de combustible en el período",
    "Nenhum abastecimento nos últimos 30 dias": "Ninguna carga de combustible en los últimos 30 días",
    "O cliente paga %{valor} a menos em cada litro e gasta 1 ponto por abastecimento (não por litro).": "El cliente paga %{valor} menos en cada litro y gasta 1 punto por carga de combustible (no por litro).",
    "Quem não tem pontos não vê a opção com pontos.": "Quien no tiene puntos no ve la opción con puntos.",
    "gastando 1 ponto por abastecimento": "gastando 1 punto por carga",
    "ou %{valor} gastando 1 ponto por abastecimento": "o %{valor} gastando 1 punto por carga",
};

export default catalogo;
